<script>
export default {
    name: "smart-loop-number-setting",
    props: {
        disabled: Boolean,
        limits: {},
        value: {},
        smartLoop: {},
    },
    computed: {
        label() {
            if (this.smartLoop === 5) return Lang.langGet("max. Elements");
            if (this.smartLoop === 6) return Lang.langGet("max. Duration [s]");

            return Lang.langGet("Frequency [1/h]");
        },
        placeholder() {
            if (this.smartLoop === 5) return '2';
            if (this.smartLoop === 6) return '60';

            return '6';
        }
    }
}
</script>

<template>
    <number-field
        outlined
        dense
        hide-details="auto"
        :value="value"
        :label="label"
        :disabled="disabled"
        :limits="limits"
        :placeholder="placeholder"
        @input="$emit('input', $event)"
    />
</template>

